import App from './App'
import Auth from './Auth'
import API from './API'
import UI from './UI'
import Form from './Form'

export default { App, Auth, API, UI, Form }



// WEBPACK FOOTER //
// ./src/store/modules/index.js